// Suche der Vorgänge-Karte im Dashboard (T-153, 28.10.2026: „im Dashboard bei
// den Vorgängen muss man nach Vorgängen auch suchen können“). Die Karte hat
// ihre Vorgänge schon im Browser — gesucht wird deshalb dort, ohne neuen
// Server-Weg. Die Zerlegung folgt der Server-Suche (`suchTokens` in
// apps/api/src/such-tokens.util.ts): an Leerzeichen UND Komma, jedes Wort muss
// passen. Zusätzlich sind Umlaute gefaltet, damit „Mueller“ auch „Müller“ findet.

/** Kleinschreibung, ä→ae, ö→oe, ü→ue, ß→ss, übrige Akzente weg. */
const falten = (s: string): string =>
    s
        .toLowerCase()
        .replace(/ä/g, "ae")
        .replace(/ö/g, "oe")
        .replace(/ü/g, "ue")
        .replace(/ß/g, "ss")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "");

/** Suchtext → gefaltete Wörter. Lauter Trennzeichen ergeben `[]` (= keine Suche). */
export const vorgangSuchTokens = (q: string): string[] =>
    falten(q.trim()).split(/[\s,]+/).filter(Boolean);

/**
 * Passt der Vorgang zu ALLEN Wörtern? Gesucht wird in Titel, Kunde und
 * Vorgangsnummer. Die Felder stehen mit Zeilenumbruch getrennt im Heuhaufen —
 * ein Wort (ohne Leerraum) kann so nicht über eine Feldgrenze hinweg treffen.
 */
export function passtZurVorgangSuche(
    v: { titel?: string | null; kunde?: string | null; vorgangNbr?: string | null },
    tokens: string[],
): boolean {
    if (tokens.length === 0) return true;
    const heuhaufen = falten([v.titel, v.kunde, v.vorgangNbr].filter(Boolean).join("\n"));
    return tokens.every((t) => heuhaufen.includes(t));
}
